import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  getListTimeKeepingHRStart,
  getListTimeKeepingHRSuccess,
  getListTimeKeepingHRFailed,
} from "../redux/getListTimeKeepingHR";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { SCREEN } from "helper/roleChecker/Screens";
import { formFilterTimeKeepingHRSelector } from "../redux/selector";
import { getListTimeKeepingHRApi } from "core/http/service/timeKeeping";

function* getListTimeKeepingHRWork() {
  const { offset, limit } = yield select(
    controlInfinitiveScrollSelector("timeKeepingHR")
  );
  const form = yield select(formFilterTimeKeepingHRSelector);

  const params = { offset, limit, ...form };
  try {
    const res = yield call(getListTimeKeepingHRApi, {
      params,
      screenCode: SCREEN.IP_021,
    });
    yield put({
      type: getListTimeKeepingHRSuccess.type,
      payload: {
        data: res.data,
        categoryName: res.categoryName,
        totalRecords: res.totalRecords,
      },
    });
  } catch (error: any) {
    yield put({
      type: getListTimeKeepingHRFailed.type,
    });
  }
}

function* watchGetListTimeKeepingHR() {
  yield takeLatest(getListTimeKeepingHRStart.type, getListTimeKeepingHRWork);
}

export default function* getListTimeKeepingHRSaga() {
  yield all([watchGetListTimeKeepingHR()]);
}
